import { HORIZONTAL_ASPECTS_STRING, SQUARE_ASPECTS_STRING } from '@anm/data/aspects';

import { TemplateFooter, TemplateHeader, TemplatePage } from './types';
import { TEMPLATES_AMOUNT } from '@anm/constants/templates_amount';

export const MAIN_PAGE_HEADER: TemplateHeader = {
  color: '#AFEDF8',
  icon: 'images/video-templates/main.jpg',
  title: 'Free Video Templates',
  title_meta: `${TEMPLATES_AMOUNT}+ Customizable Free Video Templates`,
  description_meta:
    'Wave.video is your one stop shop for creating and editing videos. Choose one of our professionally designed video ' +
    'templates or start with a blank video today.',
  description:
    'Create eye-pleasing and engaging video content with our professionally designed free video templates. Easily ' +
    'customize these templates to your brand and share them with your audience in a matter of a few clicks!'
};

export const MAIN_PAGE_FOOTER: TemplateFooter = {
  category: '',
  description:
    'With extensive collection of easy-to-edit and free video templates, you won’t need to spend a fortune ' +
    'on video production. Just select a template that you prefer and effortlessly customize it to your taste. Then, ' +
    'download the video, share it directly on social media, or embed it on your website. Step up your video marketing ' +
    'game with Wave.video free templates!'
};

const mainPage: TemplatePage = {
  header: MAIN_PAGE_HEADER,
  footer: MAIN_PAGE_FOOTER,
  content: [
    {
      type: 'slider',
      name: 'live-streaming',
      title: 'Live streaming',
      storeKey: 'live-streaming',
      isUpdateAspects: false,
      search: {
        name: 'livestreaming',
        tags: 'livestreaming',
        aspects: HORIZONTAL_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      name: 'all-templates',
      title: 'New templates',
      storeKey: 'all-templates',
      search: {
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      name: 'popular',
      title: 'Most Popular',
      storeKey: 'popular',
      search: {
        name: 'popular',
        tags: 'popular',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'slider',
      title: 'Special offers and sales',
      name: 'use-cases-special-offers',
      search: {
        category: '/Use Cases/Special Offers & Sales',
        aspects: SQUARE_ASPECTS_STRING
      }
    },
    {
      type: 'calendar'
    },
    {
      type: 'slider',
      name: 'ads-promo-testimonials',
      title: 'Customer Testimonials',
      search: {
        aspects: SQUARE_ASPECTS_STRING,
        category: '/Use Cases/Customer Testimonial'
      }
    },
    {
      type: 'slider',
      name: 'use-cases-listicles',
      title: 'Listicles',
      search: {
        aspects: SQUARE_ASPECTS_STRING,
        category: '/Use Cases/Listicles'
      }
    },
    {
      type: 'slider',
      name: 'use-cases-intro-outro',
      title: 'Intro & Outro',
      search: {
        aspects: SQUARE_ASPECTS_STRING,
        category: '/Use Cases/Intro & Outro'
      }
    }
  ]
};

export default mainPage;
